<template>
    <v-col>
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn d-flex justify-space-between">
                <h1>{{ $t("tours_types.edit_tours_types") }}</h1>
                <v-btn
                    :loading="deleteLoading"
                    class="delete"
                    elevation="0"
                    small
                    dark
                    @click="confirmDialog = true"
                >
                    <v-icon class="mr-1" size="16">mdi-delete</v-icon>
                    {{ $t("global.delete") }}
                </v-btn>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_tours_types">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("tours_types.tours_infos") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="designation"
                                    :label="$t('tours_types.designation')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-menu
                                    v-model="menuDatePicker"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="auto"
                                    offset-y
                                    transition="scale-transition"
                                >
                                    <template #activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dateRangeText"
                                            :label="$t('tours_types.dates')"
                                            append-icon="mdi-calendar-range"
                                            dense
                                            hide-details="auto"
                                            light
                                            outlined
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="selectedDates"
                                        range
                                    >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12">
                                <div class="checkbox-line">
                                    <v-checkbox
                                        v-model="isMonday"
                                        :label="$t('tours_types.monday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="isTuesday"
                                        :label="$t('tours_types.tuesday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="isWednesday"
                                        :label="$t('tours_types.wednesday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="isThursday"
                                        :label="$t('tours_types.thursday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="isFriday"
                                        :label="$t('tours_types.friday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="isSaturday"
                                        :label="$t('tours_types.saturday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="isSunday"
                                        :label="$t('tours_types.sunday')"
                                        color="primary"
                                        hide-details="auto"
                                    ></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <v-btn color="primary" elevation="0" @click="save">
                    {{ $t("global.save") }}
                </v-btn>
            </v-form>
        </div>

        <confirm-delete
            :message="$t('tours_types.going_to_delete', [designation])"
            :visible="confirmDialog"
            @close="confirmDialog = false"
            @validate="deleteTourType"
        />
    </v-col>
</template>

<script>
import ConfirmDelete from "../../../components/dialogs/confirmDelete";

export default {
    name: "EditToursTypes",
    components: {
        ConfirmDelete
    },
    data() {
        return {
            designation: "Désignation",
            selectedDates: [],
            menuDatePicker: false,
            isMonday: true,
            isTuesday: true,
            isWednesday: false,
            isThursday: true,
            isFriday: true,
            isSaturday: false,
            isSunday: false,
            deleteLoading: false,
            original: null,
            confirmDialog: false
        };
    },
    computed: {
        dateRangeText() {
            if (!this.selectedDates)
                return ""

            return this.selectedDates
                .map(date => date.toDate()).sort().join(' ~ ')
        },
    },
    mounted() {
        this.getTourType(this.$route.params.id)
    },
    methods: {
        async getTourType(id) {
            try {
                this.parseTourType(
                    (await this.$api.tour_types.get(id)).data.data
                )
            } catch (e) {

            }
        },
        parseTourType(tourType) {
            this.original = tourType
            this.designation = tourType.designation
            this.isMonday = tourType.is_monday
            this.isTuesday = tourType.is_tuesday
            this.isWednesday = tourType.is_wednesday
            this.isThursday = tourType.is_thursday
            this.isFriday = tourType.is_friday
            this.isSaturday = tourType.is_saturday
            this.isSunday = tourType.is_sunday
            if (tourType.start_date) {
                this.selectedDates.push(tourType.start_date)
                this.selectedDates.push(tourType.end_date)
            }
        },
        async deleteTourType() {
            try {
                this.deleteLoading = true
                await this.$api.tour_types.delete(this.$route.params.id)
                this.$router.push({
                    name: 'tours_types'
                })
                this.deleteLoading = false
            } catch (e) {
                this.deleteLoading = false
            }

            this.confirmDialog = false;
        },
        save() {
            try {
                this.loading = true
                let tourType = {
                    designation: this.designation,
                    start_date: this.selectedDates[0],
                    end_date: this.selectedDates[1],
                    is_monday: this.isMonday,
                    is_tuesday: this.isTuesday,
                    is_wednesday: this.isWednesday,
                    is_thursday: this.isThursday,
                    is_friday: this.isFriday,
                    is_saturday: this.isSaturday,
                    is_sunday: this.isSunday,
                }
                if (tourType.designation === this.original.designation) {
                    delete tourType.designation
                }
                this.$api.tour_types.update(this.$route.params.id, tourType).then(() => this.$router.push({name: 'tours_types'}))
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        }
    },

};
</script>
